import { render, staticRenderFns } from "./AddAccountPosting.vue?vue&type=template&id=0958a028&"
import script from "./AddAccountPosting.vue?vue&type=script&lang=js&"
export * from "./AddAccountPosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports